import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import useAnchor from "@store/Framework/Common/Hooks/useAnchor";
import useExpandProps, { ExpandStyles } from "@store/Framework/Common/Hooks/useExpandProps";
import textToSafeId from "@store/Framework/Common/Utilities/textToSafeId";
import { spacingStyles } from "@store/Themes/common/mixins/spacing";
import React, { FC, useMemo } from "react";

interface OwnProps extends ExpandStyles<AnchorHeadingStyles> {
    title: string;
    anchor: string;
    label?: string;
    forwardAs?: TypographyPresentationProps["forwardAs"];
    variant?: TypographyPresentationProps["variant"];
}

type Props = OwnProps;

export interface AnchorHeadingStyles {
    title?: TypographyPresentationProps;
}

export const AnchorHeadingStyles: AnchorHeadingStyles = {
    title: {
        variant: "h2",
        css: spacingStyles(),
    },
};

const AnchorHeading: FC<Props> = ({ title, anchor, label, variant, forwardAs, extendedStyles, overridedStyles }) => {
    const styles = useExpandProps(AnchorHeadingStyles, extendedStyles, overridedStyles);
    const safeAnchor = useMemo(() => textToSafeId(anchor), [anchor]);
    const titleStyle: TypographyPresentationProps = useMemo(
        () => ({
            ...styles.title,
            forwardAs: forwardAs || styles.title?.forwardAs,
            variant: variant || styles.title?.variant,
        }),
        [forwardAs, variant, extendedStyles, overridedStyles],
    );

    useAnchor(safeAnchor, label || title);

    return (
        <Typography id={safeAnchor} {...titleStyle}>
            {title}
        </Typography>
    );
};

export default AnchorHeading;
